import React, { ComponentProps } from "react";

export default function MastercardIcon(props: ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="15"
      viewBox="0 0 20 15"
      fill="none"
      {...props}
    >
      <path
        d="M17.6471 0.0310669H2.35294C1.05345 0.0310669 0 1.08451 0 2.38401V11.7958C0 13.0953 1.05345 14.1487 2.35294 14.1487H17.6471C18.9466 14.1487 20 13.0953 20 11.7958V2.38401C20 1.08451 18.9466 0.0310669 17.6471 0.0310669Z"
        fill="#0A2540"
      />
      <path
        d="M7.05951 11.3259C9.3986 11.3259 11.2948 9.42967 11.2948 7.09058C11.2948 4.75149 9.3986 2.85529 7.05951 2.85529C4.72042 2.85529 2.82422 4.75149 2.82422 7.09058C2.82422 9.42967 4.72042 11.3259 7.05951 11.3259Z"
        fill="#ED0006"
      />
      <path
        d="M12.706 11.3259C15.0451 11.3259 16.9413 9.42967 16.9413 7.09058C16.9413 4.75149 15.0451 2.85529 12.706 2.85529C10.3669 2.85529 8.4707 4.75149 8.4707 7.09058C8.4707 9.42967 10.3669 11.3259 12.706 11.3259Z"
        fill="#F9A000"
      />
      <path
        d="M9.88219 3.93732C10.3251 4.33453 10.6793 4.8206 10.9218 5.36385C11.1643 5.9071 11.2896 6.49534 11.2896 7.09026C11.2896 7.68518 11.1643 8.27342 10.9218 8.81667C10.6793 9.35992 10.3251 9.84598 9.88219 10.2432C9.44344 9.8551 9.09048 9.37976 8.84584 8.84753C8.60121 8.3153 8.47028 7.7379 8.46142 7.15221C8.45256 6.56652 8.56597 5.98542 8.7944 5.44604C9.02283 4.90666 9.36126 4.42086 9.78807 4.01967L9.88219 3.93732Z"
        fill="#FF5D00"
      />
    </svg>
  );
}
